<template>
	<div class="row">
		<component v-for="(field, index) in schema" 
		           :key="index"
		           :is="field.fieldtype"
		           v-model="value"
		           v-bind="field">

		</component>

	</div>
</template>
<script>
	import DIGIT from "./DIGIT.vue";
	import COMBO from "./COMBO.vue";
	import ALPHANUM from "./ALPHANUM.vue";
	import UPRSTRING from "./UPRSTRING.vue";
	import COMBINE from "./COMBINE.vue";
	import COMBO2 from "./CASCADE.vue";	
	import DATE from "./DATE.vue";	
	export default {
	name: "FormGenerator",
	inject: ['$validator'],
	components: { DIGIT, COMBO, ALPHANUM, UPRSTRING,COMBINE,COMBO2,DATE },
	props: ["schema", "value"],

	};
</script>

<style scoped>
input[type="text"] {
  text-transform: uppercase;
}

